import { Component3D } from './Component3D';
import { QuizActionEvent } from '../../../constants/QuizActionEvent';

export class ButtonComponent3D extends Component3D {
    _backMesh;
    #clickAction;

    constructor(clickAction) {
        super();

        this.#clickAction = clickAction;
    }

    _setup() {
        super._setup();
        this.hasStart = true;
        this.clickable = true;
    }

    // INTERACTION
    start() {
        if (!this.clickable) return;

        if (!this._mainClickTarget) return;

        const target = this._mainClickTarget;

        this.layers.set(1);

        target.layers.set(1);
        target.cursor = 'pointer';

        const handler = () => {
            if (!this.clickAction) return;
            this.dispatchAction(this.clickAction);
        };

        const over = () => {
            this.setOver();
        };

        const out = () => {
            this.setOut();
        };

        target.on('click', handler);
        target.on('mouseover', over);
        target.on('mouseout', out);

        this._handlers = handler;
        this._overHandlers = over;
        this._outHandlers = out;
    }

    stop() {
        if (!this._mainClickTarget) return;

        const target = this._mainClickTarget;

        if (this._handlers) {
            target.layers.set(0);
            target.cursor = 'default';

            target.off('click', this._handlers);
            target.off('mouseover', this._overHandlers);
            target.off('mouseout', this._outHandlers);
        }

        this._handlers = undefined;
        this._overHandlers = undefined;
        this._outHandlers = undefined;
    }

    dispatchAction(action) {
        if (!this.clickable || !this.visible) return;

        this.dispatchEvent({
            type: QuizActionEvent,
            action
        });
    }

    // eslint-disable-next-line class-methods-use-this
    setOver() {
        // Override to fulfill a transition
    }

    // eslint-disable-next-line class-methods-use-this
    setOut() {
        // Override to fulfill a transition
    }

    set clickAction(val) {
        this.#clickAction = val;
    }

    get clickAction() {
        return this.#clickAction;
    }
}
